var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable no-var */
import { isEmpty } from "lodash";
import { useCallback, useContext, useEffect, useState } from "react";
import { addToBasket, modifyOrderInBasket } from "src/apis/dashboard";
const { REACT_APP_URL_ASSET_BASE_PATH, REACT_APP_VERSION, REACT_APP_ENV } = process.env;
// import { scriptDetailsForFOOrder } from "src/apis/dashboard";
// import DepthChart from "src/components/depth-chart/depth";
import StepNumberInput from "src/components/inputs/step-number-input";
import { useAppDispatch } from "src/hooks/redux";
import { openAddToBasketModal } from "src/redux/reducers/modals";
import { CURRENCY_DECIMAL_LENGTH_LIMIT, DECIMAL_LENGTH_LIMIT, } from "src/utils/constant";
import { getExchFromDisplayText, getOrderValidityFromDayType, handleDecimalLimit, splitAndGetDetailsFromLongName, } from "src/utils/methods";
import { captureAddToBasket } from "src/utils/analytics";
import styles from "./buyform.module.scss";
import useOrderRequestHook from "./useOrderRequestHook";
import { SESSION_KEYS, getDataFromSession } from "src/utils/session-storage";
import { PricePickerContext } from "src/contexts/custom-context";
import moment from "moment";
const RegularStopLossBuyForm = ({ scripData, lotSize, scripPriceData, formType, returnValue, execute, executeCallback, afterMarketHours, validityDate, productType, timeType, dayType, disclosedQuantity, isFormValid, isLoading: isLoadingBuyform, sliceLimitData, toggleSliceConsent, fetchSetting, isBuyForm, }) => {
    // const googleInput = React.createRef();
    const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
    const dispatch = useAppDispatch();
    const [isLoading, setLoading] = useState(false);
    const setLoadingCallback = (newValue) => {
        setLoading(newValue);
    };
    const [priceType, setPriceType] = useState("market");
    const [price, setPrice] = useState("0");
    const [priceErrorMessage, setPriceErrorMessage] = useState("");
    const [stopLossTriggerPrice, setStopLossTriggerPrice] = useState("0");
    const [isSltErrorVisible, setSltErrorVisible] = useState(false);
    const [sltErrorMessage, setSltErrorMessage] = useState("");
    const [stockQuantity, setStockQuantity] = useState(0);
    const [stockQtyErrorMessage, setStockQtyErrorMessage] = useState("");
    const { picker, setPicker } = useContext(PricePickerContext);
    useEffect(() => {
        onPriceChange(picker.price + "");
        setPriceType(picker.type);
        //onPriceTypeChange(picker.type);
    }, [picker.price]);
    useEffect(() => {
        if (scripData === null || scripData === void 0 ? void 0 : scripData.isLimit) {
            onPriceTypeChange("limit");
            onPriceChange(scripData.lastTradePrice + "");
        }
    }, [scripData]);
    //Not working as of now
    const [toggleHideAndShow, setToggleHNS] = useState(false);
    const { getRequestOrderReqJson, sendOrderRequest, executeOrder } = useOrderRequestHook({
        afterMarketHours,
        clientCode,
        validityDate,
        dayType,
        disclosedQuantity,
        formType,
        price,
        priceType,
        productType,
        scripData,
        stockQuantity,
        stopLossTriggerPrice,
        timeType,
        lotSize,
        sliceLimitData,
        executeCallback,
        toggleSliceConsent,
        setLoading: setLoadingCallback,
        bulkModifyArray: scripData.bulkModifyArray,
    });
    const setStockQuantityCallback = useCallback((newValue, isInput = false) => {
        if (newValue != stockQuantity && newValue > 0) {
            if (fetchSetting.qty && !isInput) {
                const newQuantity = fetchSetting.key == "fno"
                    ? fetchSetting.qty * lotSize
                    : fetchSetting.qty;
                if (newQuantity !== stockQuantity) {
                    setStockQuantity(newQuantity);
                }
            }
            else {
                setStockQuantity(newValue);
            }
        }
    }, [fetchSetting.qty, lotSize]);
    const onAddToBasket = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const priceInPaisa = Math.round(parseFloat(price) * (scripData.exchangeType == "U" ? 10000000 : 100));
        if (!isEmpty(validityDate)) {
            validityDate = validityDate
                .replace("/Date(", "")
                .replace(")/", "")
                .split("+")[0];
        }
        const validity = dayType == "vtd" && !isEmpty(validityDate)
            ? new Date(Number(validityDate))
            : new Date();
        validity.setHours(23);
        validity.setMinutes(59);
        validity.setSeconds(59);
        validity.setMilliseconds(999);
        const nameBreakup = splitAndGetDetailsFromLongName(scripData.name);
        const tempValidityDate = `/Date(${moment(validity.getTime()).format("X") + "+0530"})/`;
        const payload = {
            name: scripData.name,
            Exchange: getExchFromDisplayText(scripPriceData.exchange),
            ExchangeType: scripPriceData.exchangeType,
            ScripCode: scripData.scripCode,
            Price: priceInPaisa,
            OrderType: formType,
            Qty: stockQuantity,
            AtMarket: priceType == "market" ? true : false,
            StopLossPrice: parseFloat(stopLossTriggerPrice) *
                (scripData.exchangeType == "U" ? 10000000 : 100),
            IsStopLossOrder: timeType == "stoploss" ? true : false,
            IOCOrder: dayType == "ioc",
            DelvIntra: productType == "delivery" ? "D" : "I",
            IsIntraday: productType == "delivery" ? false : true,
            AHPlaced: "N",
            PublicIP: "0.0.0.0",
            DisQty: disclosedQuantity,
            iOrderValidity: getOrderValidityFromDayType(dayType),
            AppSource: "21",
            orderFor: scripData.orderFor,
        };
        if (nameBreakup.expiry && nameBreakup.expiry.length > 0) {
            const tempExpiry = `/Date(${moment(nameBreakup.expiry).set("hour", 14).set("minute", 30).valueOf() +
                "+0530"})/`;
            payload.ExpiryDate = tempExpiry;
            payload.StrikeRate = nameBreakup.strikeRate ? nameBreakup.strikeRate : 0;
        }
        // OTHER THAN OPTION , SEND XX FOR ALL
        // LATEST CHANGE - BACKEND DONT NEED CP TYPE FOR MODIFY OPTION
        payload.CPType = "XX";
        try {
            setLoadingCallback(true);
            if (scripData.orderFor == "M" && scripData.orderData) {
                const body = Object.assign(Object.assign({}, payload), { ValidTillDate: tempValidityDate, OrderID: ((_a = scripData.orderData) === null || _a === void 0 ? void 0 : _a.OrderID)
                        ? scripData.orderData.OrderID
                        : 0 });
                const resp = yield modifyOrderInBasket(body);
                const message = resp.data.body.Message;
                // dispatch(marginUpdate(true));
                if (resp == null || resp.data.body.Status != 0) {
                    executeCallback(false, message, resp.data.body.Status);
                }
                else {
                    executeCallback(true, "Order modified successfully.", resp.data.body.Status);
                }
            }
            else if (scripData.basketIds) {
                const body = Object.assign(Object.assign({}, payload), { BasketIDs: scripData.basketIds, ValidTillDate: validity.getTime() + "" });
                const resp = yield addToBasket(body);
                const addOrderToBasketResData = resp.data.body.AddOrderToBasketResData;
                const message = resp.data.body.Message;
                if (addOrderToBasketResData == null) {
                    captureAddToBasket(false, payload.name);
                    executeCallback(false, message);
                }
                else {
                    captureAddToBasket(true, payload.name);
                    // if (window.dataLayer) {
                    //   window.dataLayer.push({
                    //     event: "FNO360",
                    //     eventCategory: "FNO360",
                    //     eventAction: `Add to basket - FNO`,
                    //     eventLabel: `${payload.name} - ${payload.IsIntraday} - ${
                    //       payload.Qty
                    //     } - ${payload.Price / 100}`,
                    //   });
                    // }
                    executeCallback(true, "Added to Basket" + (scripData.basketIds.length > 1 ? "s." : "."));
                }
            }
            else {
                dispatch(openAddToBasketModal(payload));
                executeCallback(false);
            }
        }
        catch (error) {
            captureAddToBasket(false, payload.name);
        }
        finally {
            setLoadingCallback(false);
            executeCallback(false);
        }
    }), [
        execute,
        dayType,
        disclosedQuantity,
        dispatch,
        formType,
        price,
        priceType,
        productType,
        scripData.orderFor,
        scripData.scripCode,
        scripPriceData.exchange,
        scripPriceData.exchangeType,
        stockQuantity,
        stopLossTriggerPrice,
        timeType,
        validityDate,
    ]);
    const sendOrderRequestWrapper = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c;
        if (((_c = (_b = scripData === null || scripData === void 0 ? void 0 : scripData.bulkModifyArray) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0) {
            executeOrder(getRequestOrderReqJson());
        }
        else {
            sendOrderRequest(getRequestOrderReqJson());
        }
    });
    // useEffect(() => {
    //   onPriceTypeChange(fetchSetting.priceType);
    // }, [fetchSetting]);
    useEffect(() => {
        if (timeType == "regular") {
            setStopLossTriggerCallback("0");
            setSltErrorVisible(false);
        }
    }, [timeType]);
    useEffect(() => {
        if (isLoadingBuyform) {
            setStockQuantityCallback(0);
        }
        else if (stockQuantity <= 0) {
            setStockQuantityCallback(scripData.exchange == "M" ? 1 : lotSize);
        }
    }, [
        lotSize,
        scripData.exchange,
        stockQuantity,
        isLoadingBuyform,
        scripData.orderData,
        // setStockQuantityCallback,
    ]);
    useEffect(() => {
        setStockQuantityCallback(fetchSetting.qty);
    }, [scripData]);
    useEffect(() => {
        if (scripData.orderData || scripData.netPositionDetail) {
        }
        else {
            setStockQuantityCallback(scripData.exchange == "M" ? 1 : lotSize);
        }
    }, [scripData, lotSize]);
    //================================Quantity and above close=======================
    const setStopLossTriggerCallback = useCallback((newValue) => {
        setStopLossTriggerPrice(scripPriceData.exchangeType == "U"
            ? handleDecimalLimit(newValue, CURRENCY_DECIMAL_LENGTH_LIMIT)
            : handleDecimalLimit(newValue, DECIMAL_LENGTH_LIMIT));
        setSltErrorVisible(true);
    }, []);
    const setSltErrorMessageCallback = useCallback(() => {
        let errorMessage = "";
        if (isEmpty(stopLossTriggerPrice)) {
            errorMessage = "Stop loss trigger is compulsory";
        }
        else if (parseFloat(stopLossTriggerPrice) <= 0) {
            errorMessage = "Stop loss trigger should be geater than zero";
        }
        else if (timeType == "stoploss" && priceType == "limit") {
            if (formType == "BUY" &&
                parseFloat(stopLossTriggerPrice) >= parseFloat(price)) {
                errorMessage = "Stop loss trigger cannot be greater than price";
            }
            else if (formType == "SELL" &&
                parseFloat(stopLossTriggerPrice) <= parseFloat(price)) {
                errorMessage = "Stop loss trigger cannot be less than price";
            }
        }
        setSltErrorMessage(errorMessage);
    }, [formType, price, priceType, stopLossTriggerPrice, timeType]);
    useEffect(() => {
        setSltErrorMessageCallback();
    }, [
        formType,
        stopLossTriggerPrice,
        price,
        priceType,
        setSltErrorMessageCallback,
    ]);
    const onPriceChange = useCallback((priceValue) => {
        setPrice(scripPriceData.exchangeType == "U"
            ? handleDecimalLimit(priceValue, CURRENCY_DECIMAL_LENGTH_LIMIT)
            : handleDecimalLimit(priceValue, DECIMAL_LENGTH_LIMIT));
    }, []);
    useEffect(() => {
        if (priceType == "limit") {
            setPrice((scripPriceData === null || scripPriceData === void 0 ? void 0 : scripPriceData.exchangeType) == "U"
                ? handleDecimalLimit((scripPriceData === null || scripPriceData === void 0 ? void 0 : scripPriceData.lastTradePrice) + "", CURRENCY_DECIMAL_LENGTH_LIMIT)
                : handleDecimalLimit((scripPriceData === null || scripPriceData === void 0 ? void 0 : scripPriceData.lastTradePrice) + "", DECIMAL_LENGTH_LIMIT));
        }
    }, [scripData === null || scripData === void 0 ? void 0 : scripData.lastTradePrice]);
    const onPriceTypeChange = useCallback((type) => {
        var _a;
        if (priceType != type) {
            setPriceType(type);
            if (type == "limit") {
                onPriceChange(scripPriceData.lastTradePrice
                    ? scripPriceData.lastTradePrice + ""
                    : ((_a = scripData.orderData) === null || _a === void 0 ? void 0 : _a.Rate) + "");
            }
            else {
                onPriceChange("0");
            }
        }
    }, [priceType, scripPriceData.lastTradePrice]);
    const [showChart, setShowChart] = useState(false);
    const onEditMarketChange = useCallback(() => {
        setShowChart(!showChart);
    }, [showChart]);
    const isStopLossTriggerVisible = () => {
        if (timeType == "stoploss") {
            return true;
        }
        else {
            return false;
        }
    };
    useEffect(() => {
        returnValue(getRequestOrderReqJson());
        isFormValid(isFormValidCallback());
    }, [
        validityDate,
        formType,
        priceType,
        price,
        isLoading,
        stockQuantity,
        disclosedQuantity,
        timeType,
        stopLossTriggerPrice,
        dayType,
        productType,
        afterMarketHours,
        scripData,
        priceErrorMessage,
        sltErrorMessage,
        stockQtyErrorMessage,
    ]);
    useEffect(() => {
        if (execute) {
            if (scripData.isBasket) {
                onAddToBasket();
            }
            else {
                sendOrderRequestWrapper();
            }
        }
    }, [execute]);
    const isFormValidCallback = useCallback(() => {
        if (isLoading) {
            return false;
        }
        else if (stockQtyErrorMessage != "") {
            return false;
        }
        else if (priceErrorMessage != "") {
            return false;
        }
        else if (timeType == "stoploss" && sltErrorMessage != "") {
            return false;
        }
        else {
            return true;
        }
    }, [
        isLoading,
        priceErrorMessage,
        sltErrorMessage,
        timeType,
        stockQtyErrorMessage,
    ]);
    useEffect(() => {
        if (priceType == "limit") {
            if (isEmpty(price)) {
                setPriceErrorMessage("Price is compulsory.");
            }
            else if (parseFloat(price) <= 0) {
                setPriceErrorMessage("Price cannot be zero or negative.");
            }
            else {
                setPriceErrorMessage("");
            }
        }
        else {
            setPriceErrorMessage("");
        }
    }, [price, priceType]);
    //modify order form
    useEffect(() => {
        // console.log(JSON.stringify(scripData));
        if (scripData.netPositionDetail) {
            setStockQuantityCallback(scripData.netPositionDetail.NetQty);
        }
        if (scripData.orderData) {
            setStockQuantityCallback(scripData.orderData.Qty);
            if (scripData.orderData.SLTriggerRate != 0) {
                setStopLossTriggerCallback(scripData.orderData.SLTriggerRate + "");
            }
            else if (scripData.isBasket) {
                setStopLossTriggerCallback(scripData.orderData.StopLossPrice + "");
            }
            // if (scripData.orderData.AtMarket == "N") {
            //   onPriceTypeChange("limit");
            //   onPriceChange(scripData.orderData.Rate + "");
            // } else {
            //   onPriceTypeChange("market");
            // }
        }
        // getSliceLimitCallback();
    }, [scripData]);
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.priceInputWrapper} d-flex justify-content-between align-items-end` }, { children: [_jsx("div", Object.assign({ className: `${styles.stepInputBuyform}` }, { children: _jsx(StepNumberInput, { inputLabel: scripData.exchange == "M"
                                ? `Lot (1 Lot = ${lotSize})`
                                : "Quantity", isFocus: true, formType: formType, productType: productType, timeType: timeType, defaultValue: stockQuantity, 
                            //defaultValue={15}
                            placeholder: false, disabled: 
                            // scripData?.bulkModifyArray?.length ?? 0 > 1
                            //   ? true
                            //   : isLoadingBuyform
                            false, stepInput: scripData.exchange == "M" ? 1 : lotSize, errorMessage: "Invalid Quantity", errorMessageCallback: (errMsg) => {
                                setStockQtyErrorMessage(errMsg);
                            }, allowZero: false, showError: false, returnValue: (data) => {
                                setStockQuantityCallback(data, true);
                            }, isBuyForm: isBuyForm }) })), _jsxs("div", Object.assign({ className: `${styles.priceInput}` }, { children: [_jsxs("div", Object.assign({ className: "d-flex justify-content-between align-items-center mb-2 h-15" }, { children: [_jsx("label", { children: "Price" }), _jsxs("div", Object.assign({ className: `${styles.marketLimit}` }, { children: [_jsx("span", Object.assign({ className: priceType == "market" ? styles.active : "", onClick: () => {
                                                    onPriceTypeChange("market");
                                                    const inputElement = document.querySelector(".disabled-input");
                                                    inputElement.style.pointerEvents = "none";
                                                } }, { children: "Market" })), _jsx("span", Object.assign({ className: priceType == "limit" ? styles.active : "", onClick: () => onPriceTypeChange("limit") }, { children: "Limit" }))] }))] })), _jsx("div", Object.assign({ className: "input-group-bk d-flex", onClick: () => {
                                    onPriceTypeChange("limit");
                                    const inputElement = document.querySelector(".disabled-input");
                                    inputElement.style.pointerEvents = "auto";
                                } }, { children: _jsx("input", { type: "number", placeholder: "Market Price", className: `${styles.formControl} ${priceErrorMessage && styles.inputError} form-control-bk disabled-input`, "aria-label": "", disabled: priceType == "market", step: scripPriceData.exchangeType == "U" ? "0.0001" : "0.01", value: price + "", onWheel: (event) => {
                                        event.target.blur();
                                    }, onChange: (event) => onPriceChange(event.target.value), style: { pointerEvents: "none" } }) }))] }))] })), _jsxs("div", Object.assign({ className: `${styles.errorWrapper} d-flex justify-content-between mt-1` }, { children: [_jsxs("p", Object.assign({ className: `${styles.errorText} ${styles.errorTextLeft}` }, { children: [stockQtyErrorMessage && _jsx("span", { className: "errorIcon me-1" }), stockQtyErrorMessage] })), _jsxs("p", Object.assign({ className: `${styles.errorText} ${styles.errorTextRight}`, hidden: priceErrorMessage == "" }, { children: [priceErrorMessage && _jsx("span", { className: "errorIcon me-1" }), priceErrorMessage] }))] })), isStopLossTriggerVisible() && (_jsxs("div", Object.assign({ className: `${styles.stoplossInput} mt-3` }, { children: [_jsx("div", Object.assign({ className: "d-flex justify-content-between align-items-center mb-2 h-15" }, { children: _jsx("label", { children: "Stoploss Trigger" }) })), _jsx("input", { type: "number", placeholder: "Stop loss trigger price", className: `${styles.formControl} ${sltErrorMessage == "" || !isSltErrorVisible
                            ? ""
                            : styles.inputError}`, "aria-label": "", value: stopLossTriggerPrice, step: scripPriceData.exchangeType == "U" ? "0.0001" : "0.01", onWheel: (event) => {
                            event.target.blur();
                        }, onChange: (event) => {
                            setStopLossTriggerCallback(event.target.value);
                            // setSltErrorVisible(true);
                        } }), _jsxs("p", Object.assign({ className: `${styles.errorText} mt-2 mb-0`, hidden: sltErrorMessage == "" || !isSltErrorVisible }, { children: [sltErrorMessage && _jsx("span", { className: "errorIcon me-1" }), sltErrorMessage] }))] })))] }));
};
export default RegularStopLossBuyForm;
